import i18next from 'i18next';
import Backend, { ChainedBackendOptions } from 'i18next-chained-backend';
import HttpApi from 'i18next-http-backend'; // have a own http fallback
import resourcesToBackend from 'i18next-resources-to-backend';
import faTranslation from './fa/common.json';

const localResources = {
	fa: {
		translation: faTranslation,
	},
};

i18next.use(Backend).init<ChainedBackendOptions>({
	backend: {
		backends: [
			HttpApi, //primary
			resourcesToBackend(localResources), // fallback ,
		],
		backendOptions: [
			{
				loadPath: `https://resource.ramandtech.com/JsonResource/RamandTrader_Fa_00.json?ts=${new Date().getTime()}`,
			},
		],
	},
	fallbackLng: 'fa',
	lng: 'fa',
	preload: ['fa'],
});

export default i18next;
